import { render, staticRenderFns } from "./MobileSubscription.vue?vue&type=template&id=dd9c2e90&"
import script from "./MobileSubscription.vue?vue&type=script&lang=js&"
export * from "./MobileSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports